// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2PcdF","inner":"Form_inner__-ZMk9","range":"Form_range__1xhzs","name":"Form_name__e-YFK","actions":"Form_actions__qWPqU"};